
export function IgnoreUrlDelete(req): boolean {
  if (
    !(req.url.includes('ticket/details'))
  ) {
    return true;
  } else {
    return false;
  }
}
export function IgnoreUrlPut(req): boolean {
  if (
    !(req.url.includes('public/fcm'))
  ) {
    return true;
  } else {
    return false;
  }
}
export function IgnoreUrlPost(req): boolean {
  if (
    !(req.url.includes('ticket/details'))

  ) {
    return true;
  } else {
    return false;
  }
}
